import { Tag } from "antd"
import { useTranslation } from "react-i18next"

export function PaymentDefaultTag({ style, children, ...props }) {
  const { t } = useTranslation()

  return (
    <Tag
      color="blue-inverse"
      style={{
        margin: 0,
        flex: 1,
        border: "0px",
        borderRadius: 6,
        ...(style || {})
      }}
      {...props}
    >
      {children || t("Default")}
    </Tag>
  )
}
